import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'
import { textTruncate } from "Helpers/helpers";

const state = {
    competitors_beginDate: null,
    competitors_lastDate: null,
    competitors_datasets: [],
    competitors_state: [],
    walkingestimate_v1: [],
    //v2    
    competitor_isLoading: false,
    competitor_channels_x_date: {},
    competitor_channels_x_competitor_country: {},
    competitor_table: null,
    competitor_total: 0,
    competitor_channels: [],
    competitor_sentiment: [],


}

// getters
const getters = {
    competitor_date: state => {
        if (state.competitors_beginDate != null) {
            var _start = state.competitors_beginDate.split("T");
            var _end = state.competitors_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.competitors_beginDate, end: state.competitors_lastDate }
        }
    },
    competitor_isLoading: state => {
        return state.competitor_isLoading;
    },
    competitors_data_date: state => {
        if (state.competitors_beginDate !== null) {
            var _start = state.competitors_beginDate.split("T");
            var _end = state.competitors_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        } else {
            return "N/A"
        }
    },
    competitors_datasets: state => {
        return state.competitors_datasets;
    },
    competitors_state: state => {
        return state.competitors_state;
    },
    walkingestimate_v1: state => {
        return state.walkingestimate_v1;
    },
    competitor_table: state => {
        return state.competitor_table;
    },
}

// actions
const actions = {
    // start /v2 actions
    V2getCompetitorsDatasets(context, payload) {
        state.competitor_isLoading = true;
        var _params = {};
        // calulate _params from main_filters          
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        //get data
        instance.get('v2/market/competitor', request)
            .then(response => {
                const {
                    date,
                    competitor_channels_x_date,
                    competitor_channels_x_competitor_country,
                } = response.data;

                state.competitors_beginDate = date.start;
                state.competitors_lastDate = date.end;
                state.competitor_channels_x_date = competitor_channels_x_date;
                state.competitor_channels_x_competitor_country = competitor_channels_x_competitor_country;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "competitors_country") {
                        context.commit("V2onCompetitorsCountry", payload);
                    } else if (stateName == "walkingestimate_v1") {
                        context.commit("V2onWalkingEstimateV1", payload);
                    }
                });
                state.competitor_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/maket/competitors] syntax errors under instant.get");
            })
    },

    // getCompetitorsDatasets(context, payload) {
    //     // console.log("[store/market/competitors] getCompetitorsDatasets() DEPRECATED - excepted /competitors/56 /competitors/57");
    //     state.competitor_isLoading = true;
    //     state.competitors_country_filter = null;
    //     const request = {
    //         params: qs.parse({
    //             limit: 1,
    //             sort: "-date"
    //         })
    //     };
    //     instance.get('market/competitor', request)
    //         .then(response => {
    //             const { rows } = response.data;
    //             const date = rows.map((item) => { return item.date });

    //             var _start = moment(new Date(date)).add(-30, 'days');
    //             var _end = moment(new Date(date));
    //             var _params = {
    //                 start: _start.format("YYYY-MM-DD"),
    //                 end: _end.format("YYYY-MM-DD"),
    //                 sort: '-date'
    //             };
    //             // calulate _params from main_filters                
    //             var main_filters = payload.main_filters;
    //             if (main_filters !== null) {
    //                 if (main_filters.start !== null && main_filters.end !== null) {
    //                     _start = moment(new Date(main_filters.start));
    //                     _end = moment(new Date(main_filters.end));
    //                     _params.start = _start.format("YYYY-MM-DD");
    //                     _params.end = _end.format("YYYY-MM-DD");
    //                 }
    //                 if (main_filters.location_source !== null) {
    //                     _params.location_source = main_filters.location_source;
    //                 }
    //                 if (main_filters.location_destination != null) {
    //                     _params.location_destination = main_filters.location_destination;
    //                 }
    //             }

    //             // calulate _params from sub_filters
    //             // competitor_channels, competitor_sentiment, q, limit, page, sort
    //             _params.limit = 5;
    //             _params.page = 1;
    //             var sub_filter = payload.sub_filter;
    //             if (sub_filter !== null) {
    //                 if (sub_filter.competitor_channels !== null) {
    //                     _params.competitor_channels = sub_filter.competitor_channels;
    //                 }
    //                 if (sub_filter.competitor_sentiment !== null) {
    //                     _params.competitor_sentiment = sub_filter.competitor_sentiment;
    //                 }
    //                 if (sub_filter.q !== "") {
    //                     _params.q = sub_filter.q;
    //                 }
    //                 if (sub_filter.limit > 0) {
    //                     _params.limit = sub_filter.limit;
    //                 }
    //                 if (sub_filter.page > 0) {
    //                     _params.page = sub_filter.page;
    //                 }
    //                 if (sub_filter.sort != "") {
    //                     _params.sort = sub_filter.sort;
    //                 }
    //             }

    //             state.competitors_beginDate = moment(_start).format("YYYY-MM-DD");
    //             state.competitors_lastDate = moment(_end).format("YYYY-MM-DD");

    //             const request = {
    //                 params: qs.parse(_params)
    //             };

    //             instance.get('market/competitor', request)
    //                 .then(response => {
    //                     const { competitor_channels, competitor_sentiment, count, rows } = response.data;
    //                     state.competitor_datasets = rows;
    //                     state.competitor_total = count;
    //                     state.competitor_channels = competitor_channels;
    //                     state.competitor_sentiment = competitor_sentiment;
    //                     payload.stateDatasets.forEach(function(stateName) {
    //                         if (stateName == "competitor_table") {
    //                             context.commit("onCompetitorTable", payload);
    //                         }
    //                     });
    //                     state.competitor_isLoading = false;
    //                 })
    //                 .catch(error => {
    //                     console.log(error.response, "[store/market/competitors] syntax errors under instant.get");
    //                 })
    //         })
    //         .catch(error => {
    //             console.log(error.response);
    //         })
    // },
    getCompetitorsDatasets(context, payload) {
        // console.log("[store/market/competitors] getCompetitorsDatasets() DEPRECATED - excepted /competitors/56 /competitors/57");
        state.competitor_isLoading = true;
        state.competitors_country_filter = null;
        const request = {
            params: qs.parse({
                limit: 1,
                sort: "-date"
            })
        };
        instance.get('market/competitor', request)
            .then(response => {
                const { rows } = response.data;
                const date = rows.map((item) => { return item.date });

                var _start = moment(new Date(date)).add(-30, 'days');
                var _end = moment(new Date(date));
                var _params = {
                    start: _start.format("YYYY-MM-DD"),
                    end: _end.format("YYYY-MM-DD"),
                    sort: '-date'
                };
                // calulate _params from main_filters                
                var main_filters = payload.main_filters;
                if (main_filters !== null) {
                    if (main_filters.start !== null && main_filters.end !== null) {
                        _start = moment(new Date(main_filters.start));
                        _end = moment(new Date(main_filters.end));
                        _params.start = _start.format("YYYY-MM-DD");
                        _params.end = _end.format("YYYY-MM-DD");
                    }
                    if (main_filters.location_source !== null) {
                        _params.location_source = main_filters.location_source;
                    }
                    if (main_filters.location_destination != null) {
                        _params.location_destination = main_filters.location_destination;
                    }
                }

                // calulate _params from sub_filters
                // competitor_channels, competitor_sentiment, q, limit, page, sort
                _params.limit = 5;
                _params.page = 1;
                var sub_filter = payload.sub_filter;
                if (sub_filter !== null) {
                    if (sub_filter.competitor_channels !== null) {
                        _params.competitor_channels = sub_filter.competitor_channels;
                    }
                    if (sub_filter.competitor_sentiment !== null) {
                        _params.competitor_sentiment = sub_filter.competitor_sentiment;
                    }
                    if (sub_filter.q !== "") {
                        _params.q = sub_filter.q;
                    }
                    if (sub_filter.limit > 0) {
                        _params.limit = sub_filter.limit;
                    }
                    if (sub_filter.page > 0) {
                        _params.page = sub_filter.page;
                    }
                    if (sub_filter.sort != "") {
                        _params.sort = sub_filter.sort;
                    }
                }

                state.competitors_beginDate = moment(_start).format("YYYY-MM-DD");
                state.competitors_lastDate = moment(_end).format("YYYY-MM-DD");

                const request = {
                    params: qs.parse(_params)
                };

                instance.get('market/competitor', request)
                    .then(response => {
                        const { competitor_channels, competitor_sentiment, count, rows } = response.data;
                        state.competitor_datasets = rows;
                        state.competitor_total = count;
                        state.competitor_channels = competitor_channels;
                        state.competitor_sentiment = competitor_sentiment;
                        payload.stateDatasets.forEach(function(stateName) {
                            if (stateName == "competitor_table") {
                                context.commit("onCompetitorTable", payload);
                            }
                        });
                        state.competitor_isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response, "[store/market/competitors] syntax errors under instant.get");
                    })
            })
            .catch(error => {
                console.log(error.response);
            })
    },
}

// mutations
const mutations = {
    V2onCompetitorsCountry(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['FACEBOOK'] = '#3241a6';
        colors['INSTAGRAM'] = '#578e47';
        colors['TWITTER'] = '#cf9a41';
        colors['WEBBOARD'] = '#be4141';
        colors['WEBSITE'] = '#7d3b98';
        colors['YOUTUBE'] = '#e5e5e5';

        var rows = state.competitor_channels_x_competitor_country.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_competitor;
            var _item = {};
            var _competitor_country = item._id.competitor_country;
            var _competitor_channels = item._id.competitor_channels.toUpperCase();
            var pos = items.map(function(e) {
                return e.country;
            }).indexOf(item._id.competitor_country);
            if (pos == -1) {
                _item['country'] = item._id.competitor_country;
                _item['FACEBOOK'] = 0;
                _item['INSTAGRAM'] = 0;
                _item['TWITTER'] = 0;
                _item['WEBBOARD'] = 0;
                _item['WEBSITE'] = 0;
                _item['YOUTUBE'] = 0;
                _item[_competitor_channels] = item.sum_competitor;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_competitor_channels] != undefined) {
                    _item[_competitor_channels] += item.sum_competitor;
                } else {
                    _item[_competitor_channels] = item.sum_competitor;
                }
                items[pos] = _item;
            }
        });

        // sort by country desc        
        items.sort(function(a, b) {
            return a.country.localeCompare(b.country);
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.competitors_state = items = items
        // --- end dataset for stack chart
    },
    V2onWalkingEstimateV1(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['FACEBOOK'] = '#3241a6';
        colors['INSTAGRAM'] = '#578e47';
        colors['TWITTER'] = '#cf9a41';
        colors['WEBBOARD'] = '#be4141';
        colors['WEBSITE'] = '#7d3b98';
        colors['YOUTUBE'] = '#e5e5e5';

        var rows = state.competitor_channels_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_competitor;
            var _item = {};
            var _competitor_channels = item._id.competitor_channels.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['FACEBOOK'] = 0;
                _item['INSTAGRAM'] = 0;
                _item['TWITTER'] = 0;
                _item['WEBBOARD'] = 0;
                _item['WEBSITE'] = 0;
                _item['YOUTUBE'] = 0;
                _item[_competitor_channels] = item.sum_competitor;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_competitor_channels] != undefined) {
                    _item[_competitor_channels] += item.sum_competitor;
                } else {
                    _item[_competitor_channels] = item.sum_competitor;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }

        state.walkingestimate_v1 = items
        // --- end dataset for stack chart
    },
    onCompetitorTable(state, payload) {
        // --- start dataset for v-data-table
        /**
        {
            "id": "5bdabf523ea5940006515922",
            "competitor_name": "Amazing Thailand",
            "competitor_message": "Welcome to thailand",
            "competitor_channels": "facebook",
            "competitor_sentiment": "positive",
            "competitor_link": "https://www.facebook.com/101655275698_10156552054355699",
            "competitor_ev": 305,
            "competitor_country": "มาเลเซีย",
            "location_zone": "เอเชีย",
            "location_source": "ญี่ปุ่น",
            "location_destination": "กรุงเทพมหานคร",
            "location_destination_region": "ภาคกลาง",
            "date": "2018-10-26T00:00:00.000Z"
        }
        */
        var rows = state.competitor_datasets;
        var competitor_datatable = {
            headers: [
                { text: 'EV', value: "competitor_ev", align: 'left' },
                { text: 'Date', value: "date", align: 'left' },
                { text: 'Name', value: "competitor_name", align: 'left' },
                { text: 'Message', value: "competitor_message", align: 'left', sortable: false, style: 'width:130px;'},
                { text: 'Channels', value: "competitor_channels", align: 'left', style: 'width:130px;' },
                { text: 'Sentiment', value: "competitor_sentiment", align: 'left' },
                { text: 'Country', value: "competitor_country", align: 'left' },
                //{ text: 'Link', value: "competitor_link", align: 'center', sortable: false },
            ],
            items: [{
                value: false,
                date: '',
                competitor_name: '',
                competitor_message: '',
                competitor_channels: '',
                competitor_sentiment: '',
                competitor_country: '',
                competitor_ev: '',
                competitor_link: '',

            }],
            pagination: {
                sortBy: 'date',
                descending: false,
            },
            total: 0,
        };

        // build items
        var items = [];
        rows.forEach(function(item, index) {
            var _item = {
                value: false,
                competitor_ev: item.competitor_ev,
                date: item.date,
                competitor_name: item.competitor_name,
                competitor_message: textTruncate(item.competitor_message, 80),
                competitor_channels: item.competitor_channels,
                competitor_sentiment: item.competitor_sentiment,
                competitor_country: item.competitor_country,
                competitor_link: item.competitor_link,
            }
            items.push(_item);
        });
        competitor_datatable.items = items;
        competitor_datatable.total = state.competitor_total;

        competitor_datatable.competitor_channels = state.competitor_channels.sort(function(a, b) { return a.localeCompare(b) });
        competitor_datatable.competitor_sentiment = state.competitor_sentiment.sort(function(a, b) { return a.localeCompare(b) });
        state.competitor_table = competitor_datatable;
        // --- start dataset for v-data-table
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}